import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import type { EventId } from '@swf/generated/types/api/sports';
import Event from '@swf/sports/components/EventsList/components/Event/Event';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';

export interface DisplayConfig {
  shouldShowEventDate?: true;
}

export interface Props {
  eventId: EventId;
  displayConfig?: DisplayConfig;
}

const EventMoreMarkets: React.FC<Props> = ({ eventId, displayConfig }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const event = useSelector((state: RootState) => widgetSelect.event(state, eventId));
  const competition = useSelector((state: RootState) =>
    widgetSelect.competition(state, event.competitionId)
  );
  const eventType = useSelector((state: RootState) =>
    widgetSelect.eventType(state, event.eventTypeId)
  );

  if (!event.competitionId) return null;

  return (
    <div data-testid="event">
      <Event
        event={{
          ...event,
          eventTypeId: eventType.eventTypeId,
          eventTypeSlug: eventType.eventTypeSlug,
          competitionSlug: competition.competitionSlug,
          competitionId: competition.competitionId,
          startTime: event.eventStartTime,
          eventId: event.eventId
        }}
        shouldShowEventDate={displayConfig?.shouldShowEventDate}
      />
    </div>
  );
};

export default EventMoreMarkets;
